import {useFormikContext} from 'formik';
import {Button, Col, Form as BootstrapForm, Row} from "react-bootstrap";
import LabelRequired from "../../../../../../../component/LabelRequired";
import TextField from "../../../../../../../component/TextField";
import AutocompleteV2 from "../../../../../../../component/AutocompleteObjectV2";
import React from "react";

const GiayNghiOmForm = () => {
  const {values, errors, touched, setFieldValue, handleChange} = useFormikContext<any>();

  return (
    <>
      <Row lg={12}>
        <Col xs="12" className='spaces mb-6'>
          <div className="spaces mt-5 mb-n2 d-flex flex-row justify-content-between">
            <LabelRequired label="Chẩn đoán và phương pháp điều trị" className="min-w-125px"/>
            <Button
              className="bg-white spaces mb-2 px-2"
            >
              <u className="fw-bold color-17A2B8 fs-13px">Cập nhật từ bệnh án</u>
            </Button>
          </div>
          <TextField
            as="textarea"
            rows={4}
            name="slDiagnosisAndTreatmentMethod"
            value={values.slDiagnosisAndTreatmentMethod || ""}
            onChange={handleChange}
            className="w-100 resize-none"
            labelClassName="spaces min-w-80"
          />
        </Col>
        <Col xs="2" className='spaces mb-6'>
          <LabelRequired label="Số ngày nghỉ" className="spaces min-w-80"/>
          <TextField
            name="slNumberOfLeaveDays"
            value={values?.slNumberOfLeaveDays || ""}
            onChange={handleChange}
            className="w-100"
            labelClassName="spaces min-w-80"
          />
        </Col>
        <Col xs="2" className='spaces mb-6'>
          <LabelRequired label="Từ ngày" className="spaces min-w-80"/>
          <TextField
            name="slStartDate"
            type="date"
            value={values?.slStartDate || ""}
            onChange={handleChange}
            className="w-100"
            labelClassName="spaces min-w-80"
          />
        </Col>
        <Col xs="2" className='spaces mb-6'>
          <LabelRequired label="Đến ngày" className="spaces min-w-80"/>
          <TextField
            name="slEndDate"
            type="date"
            value={values?.slEndDate || ""}
            onChange={handleChange}
            className="w-100"
            labelClassName="spaces min-w-80"
          />
        </Col>
        <Col xs="3" className='spaces mb-6'>
          <LabelRequired label="Bác sĩ" className="spaces min-w-135"/>
          <AutocompleteV2
            options={[]}
            value={values?.slDoctorName || null}
            name="slDoctorName"
            urlData="data.data.0.terms"
            onChange={(selectedOption) => setFieldValue("slDoctorName", selectedOption)}
            touched={touched?.slDoctorName}
            errors={errors?.slDoctorName}
            className="autocomplete-custom-tiep-nhan radius spaces width-100 h-29"
          />
        </Col>
        <Col xs="3" className='spaces mb-6'>
          <LabelRequired label="Thủ trưởng đơn vị" className="spaces min-w-135 align-items-start mt-2"/>
          <AutocompleteV2
            options={[]}
            value={values?.slDepartmentHead || null}
            name="slDepartmentHead"
            urlData="data.data.0.terms"
            onChange={(selectedOption) => setFieldValue("slDepartmentHead", selectedOption)}
            touched={touched?.slDepartmentHead}
            errors={errors?.slDepartmentHead}
            className="autocomplete-custom-tiep-nhan radius spaces width-100 h-29"
          />
        </Col>
        <Col xs="4" className='spaces mb-6'>
          <LabelRequired label="Người đại diện" className="spaces min-w-80"/>
          <TextField
            name="slRepresentative"
            value={values?.slRepresentative || ""}
            onChange={handleChange}
            className="w-100"
            labelClassName="spaces min-w-80"
          />
        </Col>
        <Col xs="2" className='spaces mb-6'>
          <LabelRequired label="Số thẻ BHYT" className="spaces min-w-80"/>
          <TextField
            name="slInsCode"
            value={values?.slInsCode || ""}
            onChange={handleChange}
            className="w-100"
            labelClassName="spaces min-w-80"
          />
        </Col>
        <Col xs="2" className='spaces mb-6'>
          <LabelRequired label="Mã số BHXH" className="spaces min-w-80"/>
          <TextField
            name="slSocialInsCode"
            value={values?.slSocialInsCode || ""}
            onChange={handleChange}
            className="w-100"
            labelClassName="spaces min-w-80"
          />
        </Col>
        <Col xs="12" className='spaces mb-6'>
          <div className="spaces mt-5 mb-n2 d-flex flex-row justify-content-between">
            <LabelRequired label="Đơn vị làm việc" className="min-w-125px"/>
            <Button
              className="bg-white spaces mb-2 px-2"
            >
              <u className="fw-bold color-17A2B8 fs-13px">Chọn nơi làm việc</u>
            </Button>
          </div>
          <TextField
            as="textarea"
            rows={2}
            name="slWorkplace"
            value={values?.slWorkplace || ""}
            onChange={handleChange}
            className="w-100 resize-none"
            labelClassName="spaces min-w-80"
          />
        </Col>
      </Row>
      <Row lg={12}>
        <Col xs="12" className='spaces mb-6 mt-10'>
          <em>Thông tin cha mẹ (chỉ áp dụng đối với trường hợp là trẻ em dưới 7 tuổi)</em>
        </Col>
        <Col xs="4" className='spaces mb-6'>
          <LabelRequired label="Họ tên cha" className="spaces min-w-80"/>
          <TextField
            name="slFatherName"
            value={values?.slFatherName || ""}
            onChange={handleChange}
            className="w-100"
            labelClassName="spaces min-w-80"
          />
        </Col>
        <Col xs="4" className='spaces mb-6'>
          <LabelRequired label="Họ tên mẹ" className="spaces min-w-80"/>
          <TextField
            name="slMotherName"
            value={values?.slMotherName || ""}
            onChange={handleChange}
            className="w-100"
            labelClassName="spaces min-w-80"
          />
        </Col>
        <Col xs></Col>
        <Col xs="4" className='d-flex align-items-center justify-content-between spaces mb-6'>
          <BootstrapForm.Check
            type="checkbox"
            label="Đình chỉ thai nghén"
            name="slPregnancyTermination"
            checked={values?.slPregnancyTermination || false}
            onChange={(e) => setFieldValue("slPregnancyTermination", e.target.checked)}
          />
          <LabelRequired label="Tuổi thai"/>
        </Col>
        <Col xs="2" className='spaces mb-6'>
          <TextField
            name="slGestationalAge"
            value={values?.slGestationalAge || ""}
            onChange={handleChange}
            className="w-100"
            labelClassName="spaces min-w-80"
          />
        </Col>
        <Col xs className='d-flex align-items-center'>Tuần</Col>
        <Col xs="12" className='spaces mb-6'>
          <LabelRequired label="Nguyên nhân đình chỉ thai nghén" className="spaces min-w-80"/>
          <TextField
            as="textarea"
            rows={2}
            name="slPregnancyTerminationReason"
            value={values?.slPregnancyTerminationReason || ""}
            onChange={handleChange}
            className="w-100 resize-none"
            labelClassName="spaces min-w-80"
          />
        </Col>
        <Col xs="12" className='spaces mb-6'>
          <LabelRequired label="Ghi chú" className="spaces min-w-80"/>
          <TextField
            as="textarea"
            rows={4}
            name="slNotes"
            value={values?.slNotes || ""}
            onChange={handleChange}
            className="w-100 resize-none"
            labelClassName="spaces min-w-80"
          />
        </Col>
      </Row>
    </>
  );
};

export default GiayNghiOmForm;
